import { render } from "./SportsListView.vue?vue&type=template&id=0e5e3f78&scoped=true"
import script from "./SportsListView.vue?vue&type=script&lang=js"
export * from "./SportsListView.vue?vue&type=script&lang=js"

import "./SportsListView.vue?vue&type=style&index=0&id=0e5e3f78&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e5e3f78"]])

export default __exports__